/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".account-details[_ngcontent-%COMP%]{padding-top:20px}.account-details__form[_ngcontent-%COMP%]   mat-form-field[_ngcontent-%COMP%]{display:block;width:250px}.mat-expansion-panel-header-title[_ngcontent-%COMP%]{flex:0 0 500px}"];
export { styles as styles };
